import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { AnimationModal } from '@nfs-react/components';

import { MOBILE, FROM_TABLET } from 'helpers/styles/media';

import FormBlock from './FormBlock';

const FormFixed = ({ closePopup, isOpen }) => {
  return (
    <AnimationModal
      onClose={closePopup}
      open={isOpen}
      formMaxWidth='345'
      showCloseIcon
    >
      <FormWrapper>
        <FormBlock />
      </FormWrapper>
    </AnimationModal>
  );
};

const FormWrapper = styled.div`
  box-shadow: 0.4px 0.9px 26.7px 2.3px rgba(14, 19, 29, 0.12);
  border-radius: 20px;
  padding: 20px;
  background-color: #fff;
  z-index: 30;

  @media ${FROM_TABLET} {
    max-width: 345px;
  }

  @media ${MOBILE} {
    max-width: 336px;
    margin-bottom: 64px;
  }
`;

FormFixed.propTypes = {
  closePopup: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default FormFixed;
